import { fetchSupplierDetail } from '#/api/srm/supplier/fetchDetail';
import { fetchSupplierList } from '#/api/srm/supplier/fetchList';
import { mapSupplierRowsToSelectOptions } from '#/api/srm/supplier/fetchSelectOptions';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

function resolveSupplierLabel(supplier) {
  if (!supplier) {
    return '-';
  }
  return [supplier.code, supplier.name].filter(Boolean).join(' - ') || '-';
}

/**
 * supplier async multi filter options（ACTIVE 供應商）。
 * @param {{ keyword?: string }} param0
 */
export async function searchSupplierFilterOptions({ keyword }) {
  const result = await fetchSupplierList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapSupplierRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 supplierId 但 label cache 空時，依 id 補 label。
 * @returns {Promise<boolean>} 是否有寫入新 label（用於觸發重渲染）
 */
export async function hydrateSupplierFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchSupplierDetail(id);
      const label = resolveSupplierLabel(result?.data);
      labelCache.set(String(id), label);
    } catch {
      // 留下 unresolved；ListFilterStatus 會顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}

